import {createSlice, current} from '@reduxjs/toolkit';
import { visualIvrSteps } from './utils/constants';

const initialState = {
  currentStep: visualIvrSteps.MENU,
  categoryData : {},
};

const VisualIVRSlice = createSlice({
  name: 'VisualIVRSlice',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setCategoryData: (state, action) => {
      state.categoryData = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
  },
});

export const { setCurrentStep, saveToHistory, setCategoryData } = VisualIVRSlice.actions;
export default VisualIVRSlice.reducer;
